import React, { forwardRef, useContext, useState, useRef, useEffect } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { c as classnames } from './index-2586sEvh.js';
import { D as Drawer } from './Drawer-UJohPhw7.js';
import { M as Menu } from './Menu-qznllTn-.js';
import { M as MenuMobile } from './MenuMobile-rQkeExKP.js';
import { CoreContext } from './context/index.js';
import { A as ActionType } from './types-nwm8HIz7.js';
import { M as ModalType } from './modal-6vnX5SO3.js';
import { selectCurrentCurrencyCode } from './storeSelectors/currencies.js';
import { C as CurrencyCode, b as CURRENCY_SYMBOLS } from './currency-_kacFJHO.js';
import { b as LANGUAGE_OPTIONS } from './language-BHHwgtQp.js';
import './payment-YC9H491Y.js';

const NavigationMenu = forwardRef(({ menu }, ref) => {
    var _a, _b;
    const { t: tLabel } = useTranslation('', { keyPrefix: '$common.$labels' });
    const { useDispatch, useSelector, data: { siteConfig: { account: { accountGlobalEnable = false } = {}, header: { textMobileMenuButton = false, leftDrawerUtilities = false, mobileMenuIconOrder = [ActionType.Language, ActionType.Currency], } = {}, }, }, actions: { modal: { toggleModal }, }, } = useContext(CoreContext);
    const items = (menu === null || menu === void 0 ? void 0 : menu.items) || [];
    const [showMobileMenu, setShowMobileMenu] = useState(false);
    const menuButtonRef = useRef(null);
    const closeHandler = () => {
        setShowMobileMenu(false);
        menuButtonRef.current.focus();
    };
    const { locale } = useRouter();
    useEffect(() => {
        setShowMobileMenu(false);
    }, [locale]);
    const dispatch = useDispatch();
    const handleToggleModal = (modal) => {
        dispatch(toggleModal(modal));
    };
    const onAction = (action) => {
        let modalType;
        switch (action) {
            case ActionType.Language: {
                modalType = ModalType.Language;
                break;
            }
            case ActionType.Currency: {
                modalType = ModalType.Currency;
                break;
            }
        }
        handleToggleModal(modalType);
    };
    function setActionType(action) {
        onAction(action);
    }
    const currencyCode = (_a = useSelector(selectCurrentCurrencyCode)) !== null && _a !== void 0 ? _a : CurrencyCode.EUR;
    const onKeyUp = (e, action) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.key === ' ' || e.key === 'Enter') {
            onAction(action);
        }
    };
    const localeName = (_b = LANGUAGE_OPTIONS.find(lang => lang.value === locale)) === null || _b === void 0 ? void 0 : _b.label;
    const actionElements = {
        [ActionType.ShoppingCart]: React.createElement("div", { key: "cart" }),
        [ActionType.Language]: (React.createElement("div", { key: "language", role: "button", className: "inner nav-language", tabIndex: 0, onKeyPress: e => onKeyUp(e, ActionType.Language), onClick: () => onAction(ActionType.Language) },
            localeName && React.createElement("span", null, `${localeName} (${tLabel('europe')})`),
            React.createElement("i", { className: "icon-right-arrow" }))),
        [ActionType.Search]: React.createElement("div", { key: "search" }),
        [ActionType.Currency]: (React.createElement("div", { key: "currency", role: "button", className: "inner nav-currency", tabIndex: 0, onKeyPress: e => onKeyUp(e, ActionType.Currency), onClick: () => setActionType(ActionType.Currency) },
            React.createElement("span", { "data-testid": `currency-${currencyCode.toLowerCase()}` }, `${currencyCode} (${CURRENCY_SYMBOLS[currencyCode]})`),
            React.createElement("i", { className: "icon-right-arrow" }))),
        [ActionType.Account]: accountGlobalEnable && React.createElement("div", { key: "account" }),
    };
    return (React.createElement("div", { className: "main-nav" },
        React.createElement("button", { ref: menuButtonRef, type: "button", "data-testid": "open-menu", "aria-label": tLabel('categoriesMenu'), className: classnames('open-menu', { active: showMobileMenu, text: textMobileMenuButton }), onClick: () => setShowMobileMenu(!showMobileMenu) }, !textMobileMenuButton ? (React.createElement("span", { className: "icon-menu" },
            React.createElement("strong", null, "Categories"))) : (React.createElement("div", { className: "text-menu-button" },
            React.createElement("span", { className: "text-menu-button-icon" }),
            React.createElement("span", { className: "text-menu-button-label" }, tLabel('menu'))))),
        React.createElement("nav", { ref: ref, role: "navigation", className: "nav-top" },
            React.createElement(Menu, { items: items }),
            React.createElement(Drawer, { open: showMobileMenu, onClose: closeHandler, position: "left", name: "navigation-menu" },
                React.createElement(MenuMobile, { items: items, setShowMobileMenu: setShowMobileMenu }),
                React.createElement("div", { className: "mobile-left-utilities" }, leftDrawerUtilities && mobileMenuIconOrder.map(action => actionElements[action]))))));
});
NavigationMenu.displayName = 'NavigationMenu';

export { NavigationMenu as N };
//# sourceMappingURL=NavigationMenu-Z0FXRXKB.js.map
